<app-section-layout>
    <ng-container leftSidebar>
      <app-leftmenu
      ></app-leftmenu>    
    </ng-container>
      <ng-container mainContent>    
      <app-page-content>
        <router-outlet></router-outlet>
      </app-page-content>      
       </ng-container>
  </app-section-layout>
